import React from 'react';
import { useSelector } from 'react-redux';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { ApplicationState } from '../../../../store';
import I18n from '../../../../blocks/localization';
import DateUtility from '../../../../blocks/utils/date-utility';

const PersonalDataTab = () => {
    const client = useSelector((state: ApplicationState) => state.client.client);

    let dateOfBirth: string | Date | undefined = undefined;
    if (client?.dateOfBirth) {
        dateOfBirth = new Date(client.dateOfBirth);
        dateOfBirth.setHours(dateOfBirth.getHours() + 12);
    }

    return (
        <>
            <Row className='mb-5'>
                <Col xl={6} lg={12}>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.firstName')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={client?.firstName || ''} disabled />
                        </div>
                    </FormGroup>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.lastName')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={client?.lastName || ''} disabled />
                        </div>
                    </FormGroup>
                </Col>

                <Col xl={6} lg={12}>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.oib')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={client?.oib || ''} disabled />
                        </div>
                    </FormGroup>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.dateOfBirth')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={DateUtility.format(dateOfBirth, 'dd/mm/yyyy') || ''} disabled />
                        </div>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col xl={6} lg={12}>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.address')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={client?.address?.streetName || ''} disabled />
                        </div>
                    </FormGroup>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.postCode')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={client?.address?.postCode || ''} disabled />
                        </div>
                    </FormGroup>
                </Col>

                <Col xl={6} lg={12}>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.houseNumber')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={`${client?.address?.houseNumber || ''}${client?.address?.houseNumberAddition || ''}`} disabled />
                        </div>
                    </FormGroup>
                    <FormGroup className="row">
                        <Label className="col-form-label col-sm-3">{I18n.t('myProfile.tabs.personalData.form.administrativeArea')}</Label>
                        <div className="col-sm-9">
                            <Input type="text" value={client?.address?.cityName || ''} disabled />
                        </div>
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
};

export default PersonalDataTab;
